import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: #F9F9F9;
  border-radius: 8px;
  text-align: left;
  width: 100%;
  margin: 0 auto;
`;

export const Header = styled.div`
 display: flex;
 gap: 12px;
`

export const IconContainer = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 width: 24px
`

export const Title = styled.h1`
 color: #000000;
 font-size: 16px;
 font-weight: 600;
 line-height: 24px;
 margin: 0;
 font-family: 'Inter', sans-serif;
`

export const Body = styled.p`
 color: #000000;
 font-size: 12px;
 font-weight: 400;
 line-height: 16px;
 margin: 0;
 font-family: 'Inter', sans-serif;
 padding-left: 36px;
`